import axios from 'axios';
import { Cookies } from 'react-cookie';
import { URL_FOUNDATION } from '../../../config/keys';

const cookies = new Cookies();
const token = cookies.get('id_token') || null;

export async function getEventTypes() {
	axios.defaults.headers.common.Authorization = `${token}`;
	return await axios({
		method: 'get',
		url: `${URL_FOUNDATION}/api/crm/event-types`
	});
}

export async function getEventStatuses() {
	axios.defaults.headers.common.Authorization = `${token}`;
	return await axios({
		method: 'get',
		url: `${URL_FOUNDATION}/api/crm/event-statuses`
	});
}
